import {Component, Prop, Vue} from 'vue-property-decorator';


import firebase from "firebase";


export default class ApiClient extends Vue {

    public static async searchTweetByWord(searchWord: string, count:number = 10) {
        const searchTweetByWord = firebase.app().functions('asia-northeast1').httpsCallable('searchTweetByWord');

        const result = await searchTweetByWord({text: searchWord, count:count})
            .then((result) => {
                return result.data;
            })
            .catch((error) => {
                return {};
            });

        return result;
    }


    public static async serachTweetByHashtag(searchWord: string, count:number = 10) {
        const serachTweetByHashtag = firebase.app().functions('asia-northeast1').httpsCallable('serachTweetByHashtag');

        const result = await serachTweetByHashtag({text: searchWord, count:count})
            .then((result) => {
                return result.data;
            })
            .catch((error) => {
                return {};
            });

        return result;
    }
}

